module.exports = __webpack_public_path__ + "img/aiot_bg2.f70f5c03.png";